export default __webpack_public_path__ + "static/media/stop.ecdec618.png";